import { ColDef } from 'ag-grid-community';

export const DEFAULT_COL_DEF: ColDef = {
    flex: 1,
    resizable: true,
    suppressFillHandle: true,
    suppressMenu: true,
    sortable: false,
    unSortIcon: true,
    menuTabs: [],
    wrapHeaderText: true,
    suppressMovable: true,
    editable: false
};

export const gridOptions = { rowSelection: 'multiple' as 'multiple', suppressRowClickSelection: true };
